export function isDateString(value) {
  // matchar exakt YYYY-MM-DD eller DD.MM.YYYY
  return (
    /^\d{4}-\d{2}-\d{2}$/.test(value) || /^\d{2}\.\d{2}\.\d{4}$/.test(value)
  );
}

export function parseDate(dateString) {
  // Parse DD.MM.YYYY format
  if (/^\d{2}\.\d{2}\.\d{4}$/.test(dateString)) {
    const [day, month, year] = dateString.split('.');
    return new Date(year, month - 1, day);
  }
  // Parse YYYY-MM-DD format or let Date constructor handle it
  return new Date(dateString);
}
